module.exports = __webpack_public_path__ + "img/1.6d83d356.png";